// Production Status (PSR) — 70_ProductionStatus.jsx, 2026-11-03 (Jay 01/11). Order codes, PO numbers, EXF, PPS, PPM, IQC, C/O stay as written.
const en = {
  tourTodoT: "What waits on you",
  tourTodoB: "Steps whose plan date has passed without an actual date, HEVN changes you have not answered, and EXF dates you have not confirmed yet. Click one to see those rows.",
  tourFindT: "Find your rows",
  tourFindB: "Search by order no., PO, item or colour, and click a status to see only those rows. Every column header sorts and filters like Excel.",
  tourOpenT: "Update one order",
  tourOpenB: "Open shows the order: confirm the EXF, fill in the plan and actual date of each of the 12 steps, and read its history. An actual date cannot be in the future.",
  tourBulkT: "Update many at once",
  tourBulkB: "Tick rows (or all of them here) to set the same plan date, actual date or N/A on one step for all of them, or to confirm their required EXF.",
  tourExcelT: "Work in Excel",
  tourExcelB: "Download the rows on screen, fill in the dates in Excel (dd/Mon/yyyy, e.g. 05/Nov/2026) and upload the file. You see what will change before anything is saved; a blank cell changes nothing.",
  tourCalT: "Ship calendar",
  tourCalB: "The shipment plan by month: each order on its Required EXF (or its Confirmed EXF). Tick vendors and holiday countries, switch the chips between status and vendor, and click a day, chip or week number to list its orders. \"!\" = the date has passed and it has not shipped.",
  tourChangesT: "HEVN changes",
  tourChangesB: "When HEVN changes an EXF date or a quantity, it waits here: acknowledge it, or suggest another date for HEVN to accept.",
  tourSyncT: "Sync from Master",
  tourSyncB: "The rows come from the Master Sheet after each ledger refresh (05:30 and 13:30). Sync now reads it straight away; it takes about a minute.",
  tabCal: "Ship calendar",
  calPrev: "Previous month",
  calNext: "Next month",
  calBasis: "Date basis",
  calBasis_req: "Required EXF",
  calBasis_cfm: "Confirmed EXF",
  calView: "Chips",
  calViewStatus: "All · by status",
  calViewVendor: "By vendor",
  calVendors: "Vendors",
  calAll: "All",
  calNone: "None",
  calHolidays: "Holidays",
  calS_late: "Late",
  calS_noactual: "No actual",
  calS_noinput: "No input",
  calS_ontrack: "On track",
  calS_shipped: "Shipped",
  calMonthSum: "{{n}} order(s) · {{qty}} pcs this month",
  calMore: "{{n}} more",
  calLate: "{{n}} late",
  calPastMark: "Not shipped and the date has passed",
  calPastBtn: "Past EXF, not shipped ({{n}})",
  calListDay: "{{d}} — {{n}} order(s), {{qty}} pcs",
  calListWeek: "Week {{w}} — {{n}} order(s), {{qty}} pcs",
  calListPast: "Past EXF date and not shipped — {{n}} order(s), {{qty}} pcs",
  calEmpty: "No orders here.",
  calWeek: "Week {{w}}",
  calFallback: "Rows without a Confirmed EXF stay on their Required EXF.",
  calHolidayFail: "Could not read the {{c}} holidays from Google just now.",
  calCountry_VN: "Vietnam",
  calCountry_KR: "Korea",
  calCountry_US: "USA",
  calCountry_NL: "Netherlands",
  calCountry_SG: "Singapore",
  calCountry_JP: "Japan",
  xlDown: "Download Excel",
  xlUp: "Upload Excel",
  xlReading: "Reading the file…",
  xlPreview: "What the file changes",
  xlSummary: "{{ok}} row(s) will change, {{failed}} with a problem, {{unchanged}} unchanged. Blank cells change nothing.",
  xlApply: "Apply the changes",
  xlApplied: "{{ok}} row(s) updated from the file, {{failed}} not.",
  xlRow: "Row",
  xlRowId: "Row ID",
  nav: "Production Status",
  title: "Production Status",
  sub: "Rows come from the Master Sheet; vendors update progress, HEVN sees every vendor. Prices are never shown here.",
  subVendor: "Your open orders from Helinox. Update progress here — no Excel file is needed any more.",
  vendor: "Vendor",
  allVendors: "All vendors",
  sync: "Sync from Master",
  syncing: "Syncing… (about a minute)",
  lastSync: "Last sync {{when}}",
  synced: "Synced: {{created}} new rows, {{changed}} changed by HEVN, {{closed}} closed.",
  tabRows: "Orders",
  tabChanges: "Changes",
  todoTitle: "This week's to-do",
  todoActual: "{{n}} actual date(s) missing",
  todoChanges: "{{n}} HEVN change(s) to acknowledge",
  todoCfm: "{{n}} order(s) without your Confirmed EXF",
  search: "Search order, PO, item, colour…",
  clearFilters: "Clear filters",
  shownOf: "{{n}} of {{m}}",
  colStatus: "Status",
  colLot: "Order",
  colItem: "Item",
  colQty: "Qty",
  colReq: "Req. EXF",
  colCfm: "Cfm. EXF",
  colProgress: "Progress",
  colNext: "Next step",
  colUpdated: "Updated",
  colVendor: "Vendor",
  colAction: "Action",
  open: "Open",
  st_on_track: "On track",
  st_late_vendor: "Late · Vendor",
  st_late_dac: "Late · DAC (frame)",
  st_actual_missing: "Actual date missing",
  st_no_input: "No input",
  st_shipped: "Shipped",
  st_closed: "Closed",
  st_cancelled: "Cancelled",
  all: "All",
  changedOnly: "Changed by HEVN",
  selected: "{{n}} selected",
  bulkStep: "Step",
  bulkWhat: "Set",
  bulkActual: "Actual date",
  bulkPlan: "Plan date",
  bulkNa: "Not applicable",
  bulkCfmReq: "Confirmed EXF = Required EXF",
  today: "Today",
  apply: "Apply to selected",
  bulkDone: "{{ok}} updated, {{failed}} not updated.",
  lines: "Master lines",
  linePo: "HNX PO",
  lineCustomerPo: "Customer PO",
  lineDest: "Destination",
  cfmExf: "Confirmed EXF",
  cfmSame: "Same as required",
  cfmNotYet: "not confirmed yet",
  yourOrderNo: "Your order no.",
  remark: "Remark",
  steps: "Progress steps",
  stepPlan: "Plan",
  stepActual: "Actual",
  stepStatus: "Status",
  stepCoRef: "C/O ref.",
  ss_planned: "Planned",
  ss_done: "Done",
  ss_na: "N/A",
  ss_co: "C/O (done under an earlier order)",
  frameDac: "Frame is DAC’s — HEVN updates it.",
  reason: "Reason",
  reasonNeeded: "Changing an actual date entered before the last weekly close (Friday 17:00) needs a reason.",
  save: "Save",
  saving: "Saving…",
  saved: "Saved.",
  close: "Close",
  hevnChanges: "Changed by HEVN — please confirm",
  acknowledge: "Acknowledge",
  suggest: "Suggest another date",
  suggestSend: "Send",
  suggested: "You suggested {{d}} — waiting for HEVN",
  accept: "Accept",
  reject: "Reject",
  fld_req_exf: "EXF date",
  fld_req_qty: "Quantity",
  fld_cancelled: "Line cancelled",
  history: "History",
  noHistory: "No changes yet.",
  afterClose: "edited after weekly close",
  noRows: "No orders match.",
  noChanges: "Nothing waits for an answer.",
  chgWaitVendor: "waiting for the vendor",
  chgWaitPt: "vendor suggested {{d}} — PT to decide",
  loading: "Loading…",
  readOnly: "You can read Production Status; PT updates it.",
  step_rm_order: "RM order",
  step_rm_arrival: "RM arrival",
  step_iqc: "IQC",
  step_frame: "Frame",
  step_pps: "PPS",
  step_ppm: "PPM",
  step_cutting: "Cutting",
  step_print_emb: "Print/Emb",
  step_skin_sewing: "Skin sewing",
  step_case_sewing: "Case sewing",
  step_packing: "Packing",
  step_exf: "Ex-factory",
  lineCount: "{{n}} Master line(s)",
};
const ko = {
  tourTodoT: "처리할 일",
  tourTodoB: "계획일이 지났는데 실적일이 없는 단계, 아직 답하지 않은 HEVN 변경, 아직 확정하지 않은 EXF입니다. 누르면 해당 행만 보입니다.",
  tourFindT: "행 찾기",
  tourFindB: "주문번호, PO, 품목, 색상으로 검색하고 상태를 눌러 해당 행만 볼 수 있습니다. 각 열 머리글은 Excel처럼 정렬·필터됩니다.",
  tourOpenT: "주문 하나 수정",
  tourOpenB: "열기를 누르면 주문이 열립니다. EXF를 확정하고 12단계의 계획일·실적일을 입력하며 이력을 볼 수 있습니다. 실적일은 미래 날짜를 쓸 수 없습니다.",
  tourBulkT: "여러 건 한 번에",
  tourBulkB: "행을 체크하면(여기서 전체 선택) 한 단계에 같은 계획일·실적일·해당 없음을 넣거나, 요청 EXF로 확정할 수 있습니다.",
  tourExcelT: "Excel로 작업",
  tourExcelB: "화면의 행을 내려받아 Excel에서 날짜를 입력하고(dd/Mon/yyyy, 예: 05/Nov/2026) 업로드하세요. 저장 전에 바뀔 내용을 먼저 보여 주며, 빈 칸은 아무것도 바꾸지 않습니다.",
  tourCalT: "출고 캘린더",
  tourCalB: "월별 출고 계획: 각 주문을 요청 EXF(또는 확정 EXF)에 표시합니다. 벤더와 공휴일 국가를 선택하고, 칩을 상태별/벤더별로 바꾸고, 날짜·칩·주차를 누르면 주문 목록이 나옵니다. \"!\" = 날짜가 지났는데 미출고.",
  tourChangesT: "HEVN 변경",
  tourChangesB: "HEVN이 EXF나 수량을 바꾸면 여기에 표시됩니다. 확인하거나, 다른 날짜를 제안해 HEVN이 수락하게 하세요.",
  tourSyncT: "Master에서 동기화",
  tourSyncB: "행은 원장 갱신 후(05:30, 13:30) Master Sheet에서 가져옵니다. 지금 동기화를 누르면 바로 읽으며 약 1분 걸립니다.",
  tabCal: "출고 캘린더",
  calPrev: "이전 달",
  calNext: "다음 달",
  calBasis: "기준 날짜",
  calBasis_req: "요청 EXF",
  calBasis_cfm: "확정 EXF",
  calView: "칩",
  calViewStatus: "전체 · 상태별",
  calViewVendor: "벤더별",
  calVendors: "벤더",
  calAll: "전체",
  calNone: "없음",
  calHolidays: "공휴일",
  calS_late: "지연",
  calS_noactual: "실적 없음",
  calS_noinput: "입력 없음",
  calS_ontrack: "정상",
  calS_shipped: "출고 완료",
  calMonthSum: "이번 달 {{n}}건 · {{qty}}pcs",
  calMore: "{{n}}개 더",
  calLate: "지연 {{n}}",
  calPastMark: "날짜가 지났는데 미출고",
  calPastBtn: "EXF 경과·미출고 ({{n}})",
  calListDay: "{{d}} — {{n}}건, {{qty}}pcs",
  calListWeek: "{{w}}주 — {{n}}건, {{qty}}pcs",
  calListPast: "EXF 경과·미출고 — {{n}}건, {{qty}}pcs",
  calEmpty: "해당 주문이 없습니다.",
  calWeek: "{{w}}주",
  calFallback: "확정 EXF가 없는 행은 요청 EXF에 표시됩니다.",
  calHolidayFail: "지금은 Google에서 {{c}} 공휴일을 읽지 못했습니다.",
  calCountry_VN: "베트남",
  calCountry_KR: "한국",
  calCountry_US: "미국",
  calCountry_NL: "네덜란드",
  calCountry_SG: "싱가포르",
  calCountry_JP: "일본",
  xlDown: "Excel 다운로드",
  xlUp: "Excel 업로드",
  xlReading: "파일 읽는 중…",
  xlPreview: "파일 변경 내용",
  xlSummary: "변경 {{ok}}행, 문제 {{failed}}행, 변경 없음 {{unchanged}}행. 빈 칸은 아무것도 바꾸지 않습니다.",
  xlApply: "변경 적용",
  xlApplied: "파일에서 {{ok}}행 수정, {{failed}}행 미수정.",
  xlRow: "행",
  xlRowId: "Row ID",
  nav: "생산 현황",
  title: "생산 현황",
  sub: "행은 Master Sheet에서 생성됩니다. 협력사는 진행 상황을 입력하고 HEVN은 모든 협력사를 봅니다. 가격은 표시되지 않습니다.",
  subVendor: "Helinox의 진행 중 주문입니다. 여기에서 진행 상황을 입력하세요. 더 이상 Excel 파일이 필요 없습니다.",
  vendor: "협력사",
  allVendors: "전체 협력사",
  sync: "Master에서 동기화",
  syncing: "동기화 중… (약 1분)",
  lastSync: "마지막 동기화 {{when}}",
  synced: "동기화 완료: 신규 {{created}}행, HEVN 변경 {{changed}}건, 종료 {{closed}}건.",
  tabRows: "주문",
  tabChanges: "변경 사항",
  todoTitle: "이번 주 할 일",
  todoActual: "실적 날짜 {{n}}건 누락",
  todoChanges: "확인할 HEVN 변경 {{n}}건",
  todoCfm: "확정 EXF 미입력 {{n}}건",
  search: "주문, PO, 품목, 색상 검색…",
  clearFilters: "필터 지우기",
  shownOf: "{{m}}건 중 {{n}}건",
  colStatus: "상태",
  colLot: "주문",
  colItem: "품목",
  colQty: "수량",
  colReq: "요청 EXF",
  colCfm: "확정 EXF",
  colProgress: "진행률",
  colNext: "다음 단계",
  colUpdated: "수정일",
  colVendor: "협력사",
  colAction: "작업",
  open: "열기",
  st_on_track: "정상",
  st_late_vendor: "지연 · 협력사",
  st_late_dac: "지연 · DAC (프레임)",
  st_actual_missing: "실적 날짜 누락",
  st_no_input: "미입력",
  st_shipped: "출고",
  st_closed: "종료",
  st_cancelled: "취소",
  all: "전체",
  changedOnly: "HEVN 변경",
  selected: "{{n}}건 선택",
  bulkStep: "단계",
  bulkWhat: "입력",
  bulkActual: "실적 날짜",
  bulkPlan: "계획 날짜",
  bulkNa: "해당 없음",
  bulkCfmReq: "확정 EXF = 요청 EXF",
  today: "오늘",
  apply: "선택 항목에 적용",
  bulkDone: "{{ok}}건 수정, {{failed}}건 미수정.",
  lines: "Master 라인",
  linePo: "HNX PO",
  lineCustomerPo: "고객 PO",
  lineDest: "도착지",
  cfmExf: "확정 EXF",
  cfmSame: "요청과 동일",
  cfmNotYet: "미확정",
  yourOrderNo: "귀사 주문번호",
  remark: "비고",
  steps: "진행 단계",
  stepPlan: "계획",
  stepActual: "실적",
  stepStatus: "상태",
  stepCoRef: "C/O 참조",
  ss_planned: "계획",
  ss_done: "완료",
  ss_na: "해당 없음",
  ss_co: "C/O (이전 주문으로 완료)",
  frameDac: "프레임은 DAC 담당이며 HEVN이 입력합니다.",
  reason: "사유",
  reasonNeeded: "지난 주간 마감(금요일 17:00) 이전에 입력한 실적 날짜를 변경하려면 사유가 필요합니다.",
  save: "저장",
  saving: "저장 중…",
  saved: "저장했습니다.",
  close: "닫기",
  hevnChanges: "HEVN 변경 — 확인해 주세요",
  acknowledge: "확인",
  suggest: "다른 날짜 제안",
  suggestSend: "보내기",
  suggested: "{{d}} 제안함 — HEVN 검토 대기",
  accept: "수락",
  reject: "거절",
  fld_req_exf: "EXF 날짜",
  fld_req_qty: "수량",
  fld_cancelled: "라인 취소",
  history: "이력",
  noHistory: "아직 변경 사항이 없습니다.",
  afterClose: "주간 마감 후 수정",
  noRows: "일치하는 주문이 없습니다.",
  noChanges: "답변을 기다리는 항목이 없습니다.",
  chgWaitVendor: "협력사 확인 대기",
  chgWaitPt: "협력사 제안 {{d}} — PT 결정 필요",
  loading: "불러오는 중…",
  readOnly: "생산 현황을 볼 수 있으며 입력은 PT가 합니다.",
  step_rm_order: "원자재 발주",
  step_rm_arrival: "원자재 입고",
  step_iqc: "IQC",
  step_frame: "프레임",
  step_pps: "PPS",
  step_ppm: "PPM",
  step_cutting: "재단",
  step_print_emb: "프린트/자수",
  step_skin_sewing: "스킨 봉제",
  step_case_sewing: "케이스 봉제",
  step_packing: "포장",
  step_exf: "출고",
  lineCount: "Master {{n}}라인",
};
const vi = {
  tourTodoT: "Việc đang chờ bạn",
  tourTodoB: "Các bước đã qua ngày kế hoạch mà chưa có ngày thực tế, các thay đổi của HEVN bạn chưa trả lời, và các ngày EXF bạn chưa xác nhận. Bấm vào để xem đúng các dòng đó.",
  tourFindT: "Tìm dòng của bạn",
  tourFindB: "Tìm theo số đơn, PO, mã hàng hoặc màu, và bấm một trạng thái để chỉ xem các dòng đó. Mỗi tiêu đề cột đều sắp xếp và lọc được như Excel.",
  tourOpenT: "Cập nhật một đơn",
  tourOpenB: "Bấm Mở để xem đơn: xác nhận EXF, điền ngày kế hoạch và ngày thực tế của 12 bước, và xem lịch sử. Ngày thực tế không được là ngày trong tương lai.",
  tourBulkT: "Cập nhật nhiều đơn cùng lúc",
  tourBulkB: "Tick các dòng (hoặc chọn tất cả ở đây) để đặt cùng một ngày kế hoạch, ngày thực tế hoặc N/A cho một bước, hoặc xác nhận EXF yêu cầu cho tất cả.",
  tourExcelT: "Làm trên Excel",
  tourExcelB: "Tải các dòng đang hiện về, điền ngày trong Excel (dd/Mon/yyyy, ví dụ 05/Nov/2026) rồi tải file lên. Bạn sẽ thấy những gì thay đổi trước khi lưu; ô trống không thay đổi gì.",
  tourCalT: "Lịch xuất hàng",
  tourCalB: "Kế hoạch xuất hàng theo tháng: mỗi đơn nằm ở EXF yêu cầu (hoặc EXF xác nhận). Chọn vendor và nước có ngày lễ, đổi nhãn giữa theo trạng thái và theo vendor, bấm vào ngày, nhãn hoặc số tuần để xem danh sách đơn. \"!\" = đã qua ngày mà chưa xuất.",
  tourChangesT: "Thay đổi từ HEVN",
  tourChangesB: "Khi HEVN đổi ngày EXF hoặc số lượng, thay đổi sẽ chờ ở đây: xác nhận đã biết, hoặc đề xuất ngày khác để HEVN duyệt.",
  tourSyncT: "Đồng bộ từ Master",
  tourSyncB: "Các dòng lấy từ Master Sheet sau mỗi lần làm mới sổ (05:30 và 13:30). Bấm đồng bộ để đọc ngay; mất khoảng một phút.",
  tabCal: "Lịch xuất hàng",
  calPrev: "Tháng trước",
  calNext: "Tháng sau",
  calBasis: "Ngày căn cứ",
  calBasis_req: "EXF yêu cầu",
  calBasis_cfm: "EXF xác nhận",
  calView: "Nhãn",
  calViewStatus: "Tất cả · theo trạng thái",
  calViewVendor: "Theo vendor",
  calVendors: "Vendor",
  calAll: "Tất cả",
  calNone: "Bỏ chọn",
  calHolidays: "Ngày lễ",
  calS_late: "Trễ",
  calS_noactual: "Chưa có thực tế",
  calS_noinput: "Chưa nhập",
  calS_ontrack: "Đúng tiến độ",
  calS_shipped: "Đã xuất",
  calMonthSum: "{{n}} đơn · {{qty}} pcs trong tháng",
  calMore: "{{n}} mục nữa",
  calLate: "{{n}} trễ",
  calPastMark: "Đã qua ngày mà chưa xuất",
  calPastBtn: "Quá EXF, chưa xuất ({{n}})",
  calListDay: "{{d}} — {{n}} đơn, {{qty}} pcs",
  calListWeek: "Tuần {{w}} — {{n}} đơn, {{qty}} pcs",
  calListPast: "Quá ngày EXF mà chưa xuất — {{n}} đơn, {{qty}} pcs",
  calEmpty: "Không có đơn nào.",
  calWeek: "Tuần {{w}}",
  calFallback: "Dòng chưa có EXF xác nhận sẽ nằm ở EXF yêu cầu.",
  calHolidayFail: "Hiện chưa đọc được ngày lễ {{c}} từ Google.",
  calCountry_VN: "Việt Nam",
  calCountry_KR: "Hàn Quốc",
  calCountry_US: "Mỹ",
  calCountry_NL: "Hà Lan",
  calCountry_SG: "Singapore",
  calCountry_JP: "Nhật Bản",
  xlDown: "Tải Excel",
  xlUp: "Tải lên Excel",
  xlReading: "Đang đọc file…",
  xlPreview: "File sẽ thay đổi gì",
  xlSummary: "{{ok}} dòng sẽ thay đổi, {{failed}} dòng có lỗi, {{unchanged}} dòng không đổi. Ô trống không thay đổi gì.",
  xlApply: "Áp dụng thay đổi",
  xlApplied: "Đã cập nhật {{ok}} dòng từ file, {{failed}} dòng chưa.",
  xlRow: "Dòng",
  xlRowId: "Row ID",
  nav: "Tình trạng sản xuất",
  title: "Tình trạng sản xuất",
  sub: "Các dòng lấy từ Master Sheet; vendor cập nhật tiến độ, HEVN xem mọi vendor. Không hiển thị giá ở đây.",
  subVendor: "Các đơn đang mở của bạn từ Helinox. Cập nhật tiến độ tại đây — không cần gửi file Excel nữa.",
  vendor: "Vendor",
  allVendors: "Tất cả vendor",
  sync: "Đồng bộ từ Master",
  syncing: "Đang đồng bộ… (khoảng 1 phút)",
  lastSync: "Đồng bộ lần cuối {{when}}",
  synced: "Đã đồng bộ: {{created}} dòng mới, {{changed}} thay đổi từ HEVN, {{closed}} đóng.",
  tabRows: "Đơn hàng",
  tabChanges: "Thay đổi",
  todoTitle: "Việc cần làm tuần này",
  todoActual: "Thiếu {{n}} ngày thực tế",
  todoChanges: "{{n}} thay đổi từ HEVN cần xác nhận",
  todoCfm: "{{n}} đơn chưa có Confirmed EXF",
  search: "Tìm đơn, PO, mặt hàng, màu…",
  clearFilters: "Xóa lọc",
  shownOf: "{{n}} / {{m}}",
  colStatus: "Trạng thái",
  colLot: "Đơn",
  colItem: "Mặt hàng",
  colQty: "SL",
  colReq: "EXF yêu cầu",
  colCfm: "EXF xác nhận",
  colProgress: "Tiến độ",
  colNext: "Bước tiếp theo",
  colUpdated: "Cập nhật",
  colVendor: "Vendor",
  colAction: "Thao tác",
  open: "Mở",
  st_on_track: "Đúng tiến độ",
  st_late_vendor: "Trễ · Vendor",
  st_late_dac: "Trễ · DAC (frame)",
  st_actual_missing: "Thiếu ngày thực tế",
  st_no_input: "Chưa nhập",
  st_shipped: "Đã xuất",
  st_closed: "Đã đóng",
  st_cancelled: "Đã hủy",
  all: "Tất cả",
  changedOnly: "HEVN đã thay đổi",
  selected: "Đã chọn {{n}}",
  bulkStep: "Bước",
  bulkWhat: "Đặt",
  bulkActual: "Ngày thực tế",
  bulkPlan: "Ngày kế hoạch",
  bulkNa: "Không áp dụng",
  bulkCfmReq: "EXF xác nhận = EXF yêu cầu",
  today: "Hôm nay",
  apply: "Áp dụng cho dòng đã chọn",
  bulkDone: "Đã cập nhật {{ok}}, chưa cập nhật {{failed}}.",
  lines: "Các dòng Master",
  linePo: "HNX PO",
  lineCustomerPo: "Customer PO",
  lineDest: "Điểm đến",
  cfmExf: "EXF xác nhận",
  cfmSame: "Giống EXF yêu cầu",
  cfmNotYet: "chưa xác nhận",
  yourOrderNo: "Số đơn của bạn",
  remark: "Ghi chú",
  steps: "Các bước tiến độ",
  stepPlan: "Kế hoạch",
  stepActual: "Thực tế",
  stepStatus: "Trạng thái",
  stepCoRef: "Mã C/O",
  ss_planned: "Kế hoạch",
  ss_done: "Xong",
  ss_na: "Không áp dụng",
  ss_co: "C/O (đã làm theo đơn trước)",
  frameDac: "Frame do DAC phụ trách — HEVN cập nhật.",
  reason: "Lý do",
  reasonNeeded: "Sửa ngày thực tế đã nhập trước lần chốt tuần (thứ 6 17:00) cần ghi lý do.",
  save: "Lưu",
  saving: "Đang lưu…",
  saved: "Đã lưu.",
  close: "Đóng",
  hevnChanges: "HEVN đã thay đổi — vui lòng xác nhận",
  acknowledge: "Xác nhận",
  suggest: "Đề xuất ngày khác",
  suggestSend: "Gửi",
  suggested: "Bạn đã đề xuất {{d}} — chờ HEVN",
  accept: "Chấp nhận",
  reject: "Từ chối",
  fld_req_exf: "Ngày EXF",
  fld_req_qty: "Số lượng",
  fld_cancelled: "Dòng bị hủy",
  history: "Lịch sử",
  noHistory: "Chưa có thay đổi.",
  afterClose: "sửa sau khi chốt tuần",
  noRows: "Không có đơn phù hợp.",
  noChanges: "Không có việc nào chờ xử lý.",
  chgWaitVendor: "chờ vendor",
  chgWaitPt: "vendor đề xuất {{d}} — PT quyết",
  loading: "Đang tải…",
  readOnly: "Bạn chỉ xem được; PT cập nhật.",
  step_rm_order: "Đặt NVL",
  step_rm_arrival: "NVL về",
  step_iqc: "IQC",
  step_frame: "Frame",
  step_pps: "PPS",
  step_ppm: "PPM",
  step_cutting: "Cắt",
  step_print_emb: "In/Thêu",
  step_skin_sewing: "May skin",
  step_case_sewing: "May case",
  step_packing: "Đóng gói",
  step_exf: "Xuất xưởng",
  lineCount: "{{n}} dòng Master",
};
const zh = {
  tourTodoT: "待您处理",
  tourTodoB: "计划日期已过但没有实际日期的步骤、尚未回复的 HEVN 变更，以及尚未确认的 EXF 日期。点击即可只看这些行。",
  tourFindT: "查找您的行",
  tourFindB: "按订单号、PO、品号或颜色搜索，点击某个状态即可只看这些行。每个列标题都可像 Excel 一样排序和筛选。",
  tourOpenT: "更新一个订单",
  tourOpenB: "点击打开查看订单：确认 EXF，填写 12 个步骤的计划日期和实际日期，并查看历史。实际日期不能是未来日期。",
  tourBulkT: "批量更新",
  tourBulkB: "勾选多行（或在此全选），为同一步骤设置相同的计划日期、实际日期或 N/A，或把它们的要求 EXF 设为确认 EXF。",
  tourExcelT: "在 Excel 中处理",
  tourExcelB: "下载屏幕上的行，在 Excel 中填写日期（dd/Mon/yyyy，例如 05/Nov/2026）后上传。保存前会先显示将变更的内容；空白单元格不做任何更改。",
  tourCalT: "出货日历",
  tourCalB: "按月查看出货计划：每个订单显示在要求 EXF（或确认 EXF）当天。勾选供应商和节假日国家，在按状态与按供应商之间切换标签，点击日期、标签或周数即可列出订单。\"!\" = 日期已过但未出货。",
  tourChangesT: "HEVN 变更",
  tourChangesB: "HEVN 更改 EXF 日期或数量时会显示在这里：确认已知悉，或建议另一个日期由 HEVN 决定。",
  tourSyncT: "从 Master 同步",
  tourSyncB: "每次台账刷新后（05:30 和 13:30）从 Master Sheet 读取行。点击同步立即读取，约需一分钟。",
  tabCal: "出货日历",
  calPrev: "上个月",
  calNext: "下个月",
  calBasis: "日期依据",
  calBasis_req: "要求 EXF",
  calBasis_cfm: "确认 EXF",
  calView: "标签",
  calViewStatus: "全部 · 按状态",
  calViewVendor: "按供应商",
  calVendors: "供应商",
  calAll: "全选",
  calNone: "全不选",
  calHolidays: "节假日",
  calS_late: "延迟",
  calS_noactual: "无实际",
  calS_noinput: "未填写",
  calS_ontrack: "正常",
  calS_shipped: "已出货",
  calMonthSum: "本月 {{n}} 单 · {{qty}} pcs",
  calMore: "还有 {{n}} 项",
  calLate: "{{n}} 延迟",
  calPastMark: "日期已过但未出货",
  calPastBtn: "EXF 已过、未出货（{{n}}）",
  calListDay: "{{d}} — {{n}} 单，{{qty}} pcs",
  calListWeek: "第 {{w}} 周 — {{n}} 单，{{qty}} pcs",
  calListPast: "EXF 日期已过且未出货 — {{n}} 单，{{qty}} pcs",
  calEmpty: "没有订单。",
  calWeek: "第 {{w}} 周",
  calFallback: "没有确认 EXF 的行按要求 EXF 显示。",
  calHolidayFail: "暂时无法从 Google 读取 {{c}} 的节假日。",
  calCountry_VN: "越南",
  calCountry_KR: "韩国",
  calCountry_US: "美国",
  calCountry_NL: "荷兰",
  calCountry_SG: "新加坡",
  calCountry_JP: "日本",
  xlDown: "下载 Excel",
  xlUp: "上传 Excel",
  xlReading: "正在读取文件…",
  xlPreview: "文件将变更的内容",
  xlSummary: "{{ok}} 行将变更，{{failed}} 行有问题，{{unchanged}} 行无变化。空白单元格不做任何更改。",
  xlApply: "应用变更",
  xlApplied: "已从文件更新 {{ok}} 行，{{failed}} 行未更新。",
  xlRow: "行",
  xlRowId: "Row ID",
  nav: "生产状态",
  title: "生产状态",
  sub: "行来自 Master Sheet；供应商更新进度，HEVN 查看所有供应商。此处从不显示价格。",
  subVendor: "来自 Helinox 的进行中订单。请在此更新进度，不再需要 Excel 文件。",
  vendor: "供应商",
  allVendors: "全部供应商",
  sync: "从 Master 同步",
  syncing: "同步中…（约 1 分钟）",
  lastSync: "上次同步 {{when}}",
  synced: "已同步：新增 {{created}} 行，HEVN 变更 {{changed}} 条，关闭 {{closed}} 条。",
  tabRows: "订单",
  tabChanges: "变更",
  todoTitle: "本周待办",
  todoActual: "缺少 {{n}} 个实际日期",
  todoChanges: "{{n}} 条 HEVN 变更待确认",
  todoCfm: "{{n}} 个订单未填确认 EXF",
  search: "搜索订单、PO、品名、颜色…",
  clearFilters: "清除筛选",
  shownOf: "{{n}} / {{m}}",
  colStatus: "状态",
  colLot: "订单",
  colItem: "品名",
  colQty: "数量",
  colReq: "要求 EXF",
  colCfm: "确认 EXF",
  colProgress: "进度",
  colNext: "下一步",
  colUpdated: "更新",
  colVendor: "供应商",
  colAction: "操作",
  open: "打开",
  st_on_track: "正常",
  st_late_vendor: "延迟 · 供应商",
  st_late_dac: "延迟 · DAC（框架）",
  st_actual_missing: "缺少实际日期",
  st_no_input: "未输入",
  st_shipped: "已出货",
  st_closed: "已关闭",
  st_cancelled: "已取消",
  all: "全部",
  changedOnly: "HEVN 已变更",
  selected: "已选 {{n}}",
  bulkStep: "步骤",
  bulkWhat: "设置",
  bulkActual: "实际日期",
  bulkPlan: "计划日期",
  bulkNa: "不适用",
  bulkCfmReq: "确认 EXF = 要求 EXF",
  today: "今天",
  apply: "应用到所选",
  bulkDone: "已更新 {{ok}} 条，未更新 {{failed}} 条。",
  lines: "Master 行",
  linePo: "HNX PO",
  lineCustomerPo: "客户 PO",
  lineDest: "目的地",
  cfmExf: "确认 EXF",
  cfmSame: "与要求相同",
  cfmNotYet: "尚未确认",
  yourOrderNo: "贵方订单号",
  remark: "备注",
  steps: "进度步骤",
  stepPlan: "计划",
  stepActual: "实际",
  stepStatus: "状态",
  stepCoRef: "C/O 参考",
  ss_planned: "计划",
  ss_done: "完成",
  ss_na: "不适用",
  ss_co: "C/O（在之前订单中完成）",
  frameDac: "框架由 DAC 负责，HEVN 更新。",
  reason: "原因",
  reasonNeeded: "修改上次周结（周五 17:00）之前输入的实际日期需要填写原因。",
  save: "保存",
  saving: "保存中…",
  saved: "已保存。",
  close: "关闭",
  hevnChanges: "HEVN 已变更 — 请确认",
  acknowledge: "确认",
  suggest: "建议其他日期",
  suggestSend: "发送",
  suggested: "您建议了 {{d}} — 等待 HEVN",
  accept: "接受",
  reject: "拒绝",
  fld_req_exf: "EXF 日期",
  fld_req_qty: "数量",
  fld_cancelled: "行已取消",
  history: "历史",
  noHistory: "尚无变更。",
  afterClose: "周结后修改",
  noRows: "没有匹配的订单。",
  noChanges: "没有待处理的事项。",
  chgWaitVendor: "等待供应商",
  chgWaitPt: "供应商建议 {{d}} — 待 PT 决定",
  loading: "加载中…",
  readOnly: "您可以查看生产状态，由 PT 更新。",
  step_rm_order: "原料下单",
  step_rm_arrival: "原料到货",
  step_iqc: "IQC",
  step_frame: "框架",
  step_pps: "PPS",
  step_ppm: "PPM",
  step_cutting: "裁剪",
  step_print_emb: "印刷/刺绣",
  step_skin_sewing: "面料缝制",
  step_case_sewing: "收纳袋缝制",
  step_packing: "包装",
  step_exf: "出厂",
  lineCount: "{{n}} 条 Master 行",
};
const dictionary = { ns: 'xPsr', en, ko, vi, zh };
export default dictionary;
